import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { saveGeneralRequest } from "../../../repos/GeneralRepo";
import { IFile } from "../../../types/IFile";
import { IRequestNew, IRequestType } from "../../../types/IRequest";
import { BasicRequest } from "../Common/SubSections/BasicRequest";
import { FilesUpload } from "../Common/SubSections/FilesUpload";
import { CustomRequestSection } from "../CustomRequestSection";

interface Props {
  requestType?: IRequestType;
  title?: string;
}

export const GeneralRequestSection: FC<Props> = ({
  requestType = "GENERAL_REQUEST",
  title,
}) => {
  const [requestData, setRequestData] = useState<IRequestNew>({});
  const [storedFiles, setStoredFiles] = useState<IFile[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();
  const isHolderDeathNotification =
    requestType === "HOLDER_DEATH_NOTIFICATION";

  const onSubmit = () => {
    setIsLoading(true);
    saveGeneralRequest({
      ...requestData,
      ...(title && { title }),
      storedFiles,
      deliveryType: "INBOX",
      requestType,
    })
      .then(() => {
        setRequestData({});
        setStoredFiles([]);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  return (
    <CustomRequestSection
      sectionTitle={t("RequestTitle")}
      infoBoxTitle={t(
        isHolderDeathNotification
          ? "HolderDeathNotificationInfoBoxTitle"
          : "GeneralRequestTitle"
      )}
      infoBoxDesc={t(
        isHolderDeathNotification
          ? "HolderDeathNotificationInfoBoxDesc"
          : "GeneralRequestDesc"
      )}
      onSubmit={onSubmit}
      disableSubmit={!requestData.note || (!title && !requestData.title)}
    >
      <BasicRequest
        title={title}
        mode="GENERAL_REQUEST"
        data={requestData}
        setData={setRequestData}
        isLoading={isLoading}
      />
      <FilesUpload
        storedFiles={storedFiles}
        setStoredFiles={setStoredFiles}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </CustomRequestSection>
  );
};
